import React from 'react';
import PropTypes from 'prop-types';

import { formatMonthYear } from '@zr/common/js/profile/formatters';
import ExpandableText from '@zr/components/ExpandableText';
import { getSortedSection } from '@zr/jobseeker-public/apps/jobseeker-profile/utilities';

export function ExperienceSection({ headingLevel, experiences }) {
  const Heading = headingLevel;

  return (
    <section className="experience employer_profile_section">
      <Heading className="title">Experience</Heading>
      <ol>
        {getSortedSection(experiences).map((exp, index) => (
          <li className="item" key={`${index.toString()}exs`}>
            <h3 className="item_title">
              {exp.position}
            </h3>
            <div className="subheadlines">
              <h4 className="subheadline">
                <span className="subhead">{exp.employer}</span>
                {(exp.start_date || exp.end_date || exp.current) && (
                  <span className="dates">
                    {exp.start_date && (
                      <time dateTime={exp.start_date}>
                        {formatMonthYear(exp.start_date)}
                      </time>
                    )}
                    {(exp.start_date && !!(exp.end_date || exp.current)) && ' - '}
                    {!!(exp.end_date || exp.current) && (
                      <time dateTime={exp.end_date}>
                        {exp.current ? 'Current' : formatMonthYear(exp.end_date)}
                      </time>
                    )}
                  </span>
                )}
              </h4>
            </div>
            {!!exp.description && <ExpandableText className="description" text={exp.description} />}
          </li>
        ))}
      </ol>
    </section>
  );
}

export const PropTypeExperience = PropTypes.shape({
  position: PropTypes.string,
  employer: PropTypes.string,
  start_date: PropTypes.string,
  end_date: PropTypes.string,
  current: PropTypes.bool,
  description: PropTypes.string,
});

ExperienceSection.propTypes = {
  headingLevel: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']).isRequired,
  experiences: PropTypes.arrayOf(PropTypeExperience).isRequired,
};

export default ExperienceSection;
